import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=2f41768a&scoped=true&"
import script from "./RegisterModal.vue?vue&type=script&lang=js&"
export * from "./RegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModal.vue?vue&type=style&index=0&id=2f41768a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41768a",
  null
  
)

export default component.exports